<template>
  <v-combobox
    @change="$emit('input', $event)"
    v-bind:value="chips"
    :items="items"
    chips
    clearable
    label="Filter by tags"
    multiple
    prepend-icon="mdi-filter-variant"
    solo
  >
    <template v-slot:selection="{ attrs, item, select, selected }">
      <v-chip
        small
        v-bind="attrs"
        :input-value="selected"
        close
        @click="select"
        @click:close="remove(item)"
      >
        <strong>{{ item }}</strong>
      </v-chip>
    </template>
  </v-combobox>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {
      items: ['Member', 'Director', 'Student', 'Vendor']
    };
  },
  computed: {
    chips: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    }
  }
};
</script>
